import { render, staticRenderFns } from "./customPriceInput.vue?vue&type=template&id=31260660&scoped=true"
import script from "./customPriceInput.vue?vue&type=script&lang=js"
export * from "./customPriceInput.vue?vue&type=script&lang=js"
import style0 from "./customPriceInput.vue?vue&type=style&index=0&id=31260660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31260660",
  null
  
)

export default component.exports